var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-wrapper", style: { height: _vm.appMainHeight } },
    [
      _c("app-header", { attrs: { logoUrl: _vm.logoUrl } }),
      _vm._v(" "),
      _c("app-main", {
        style: {
          height: _vm.mainHeight,
          margin: _vm.margin,
          width: _vm.minWidth,
          background: _vm.background
        }
      }),
      _vm._v(" "),
      _c("app-footer", { attrs: { copyRight: _vm.copyRight } }),
      _vm._v(" "),
      _vm.userAlert.flag
        ? _c("user-alert", {
            attrs: { alertInfo: _vm.alertInfo },
            on: { clearFn: _vm.clearFn }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }